export const API_ROUTES = {
  authentication: {
    login: '/auth/login',
    me: '/auth/me',
    sendEmailVerificationLink: '/auth/send_email_verification',
    verifyEmail: '/auth/verify_email',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    uaePassLogin: '/auth/uaepass/login',
    uaePassCallback: '/auth/uaepass/callback',
    uaePassLogoutUrl: '/auth/uaepass/logout-url',
  },
  documents: {
    extractIdInfo: '/documents/extract-id-info',
    uploadDocument: '/documents/upload',
    processDocuments: '/documents/process-documents',
    signLetterOfConsent: (organization_id: string) =>
      `/documents/organizations/${organization_id}/authorization-letter`,
    downloadFileById: (document_id: string) => `/documents/download/${document_id}`,
    getWidgetDocuments: '/documents/widget',
  },
  accounts: {
    create: '/auth/register',
    getAccountInfo: (account_id: string) => `/accounts/${account_id}`,
    getAvailableOrganizations: (account_id: string) =>
      `/accounts/${account_id}/organizations`,
    switchOrganization: (account_id: string) => `/accounts/${account_id}`,
    updateIdentity: '/accounts/identity',
    addIdentityInfoToAccount: '/accounts/identity',
    uploadIdentityDocument: '/accounts/extraction',
  },
  organizations: {
    create: '/organizations',
    list: '/organizations',
    listBorrowerOrganizations: '/organizations/borrower-organizations',
    getDetails: (organization_id: string) => `/organizations/${organization_id}`,
    getStats: (organization_id: string) => `/organizations/${organization_id}/stats`,
    createWithType: '/organizations/type',
    patchOnboarding: (organization_id: string) =>
      `/organizations/${organization_id}/onboarding`,
    getKeyClients: (organization_id: string) =>
      `/organizations/${organization_id}/key-clients`,
    getDocuments: (organization_id: string) =>
      `/organizations/${organization_id}/documents`,
    downloadAllDocuments: (organization_id: string) =>
      `/organizations/${organization_id}/documents-batch`,
    markOnboardingAsCompleted: (organization_id: string) =>
      `/organizations/${organization_id}/onboarding-completed`,
    uploadLogo: (organization_id: string) => `/organizations/${organization_id}/logo`,
    downloadLogo: (organization_id: string) => `/organizations/${organization_id}/logo`,
    deleteLogo: (organization_id: string) => `/organizations/${organization_id}/logo`,
    markOnboardingOverviewAsShown: (organization_id: string) =>
      `/organizations/${organization_id}/mark-overview-shown`,
  },
  analytics: {
    getHeadlineKPI: '/analytics/headline-kpi',
    getCashTrendData: '/analytics/cash-trend-data',
    getBurnRateGauge: '/analytics/burn-rate-gauge',
    getRunwayTrendSeries: '/analytics/runway-trend-series',
    getProfitSpendData: '/analytics/profit-spend-data',
    getMoneyInOut: '/analytics/money-inout',
    getCustomerSalesHealth: '/analytics/customer-sales-health',
    getCustomerContribution: '/analytics/customer-contribution',
    getPaymentPerformance: '/analytics/payment-performance',
    getCashFlowForecast: '/analytics/cash-flow-forecast',
  },
  mbrif: {
    getAvailableMonths: '/mbrif/analytics/available-months',
    getHeadlineKPI: '/mbrif/analytics/headline-kpi',
    getCashTrendData: '/mbrif/analytics/cash-trend-data',
    getBurnRateGauge: '/mbrif/analytics/burn-rate-gauge',
    getRunwayTrendSeries: '/mbrif/analytics/runway-trend-series',
    getProfitSpendData: '/mbrif/analytics/profit-spend-data',
    getMoneyInOut: '/mbrif/analytics/money-inout',
    getCustomerSalesHealth: '/mbrif/analytics/customer-sales-health',
    getCustomerContribution: '/mbrif/analytics/customer-contribution',
    getPaymentPerformance: '/mbrif/analytics/payment-performance',
    getCashFlowForecast: '/mbrif/analytics/cash-flow-forecast',
    getProfitabilityAndExposure: '/mbrif/analytics/extended-kpi',
  },
  apideck: {
    createVaultSession: '/apideck/vault/sessions',
    listConnections: '/apideck/connections',
    deleteConnection: (id: string) => `/apideck/connections/${id}`,
  },
  dataImport: {
    template:       '/data-import/template',
    completeness:   '/data-import/completeness',
    upload:         '/data-import/upload',
    list:           '/data-import',
    detail:         (id: string) => `/data-import/${id}`,
    confirm:        (id: string) => `/data-import/${id}/confirm`,
    file:           (id: string) => `/data-import/${id}/file`,
  },
  csvImports: {
    list: '/data-imports',
    upload: '/data-imports',
    delete: (id: string) => `/data-imports/${id}`,
  },
  verifyWorkEmail: {
    sendCode: '/work-email/send-code',
    verifyCode: '/work-email/verify-code',
    getStatus: '/work-email/status',
    saveContactInfo: '/work-email/save-contact-info',
  },
  company: {
    list: '/companies',
    create: '/companies',
    update: (id: string) => `/companies/${id}`,
  },
  accounting: {
    triggerSync: '/accounting/sync',
    getSyncStatus: '/accounting/sync/status',
  },
  aiChat: {
    stream:        (companyId: string) => `/company/${companyId}/ai/chat/stream`,
    history:       (companyId: string) => `/company/${companyId}/ai/chat/history`,
    clearHistory:  (companyId: string) => `/company/${companyId}/ai/chat/clear`,
    conversations: (companyId: string) => `/company/${companyId}/ai/chat/conversations`,
  },
  dashboard: {
    cashTrends: (companyId: string) => `/company/${companyId}/dashboard/cash-trends`,
    profitSpend: (companyId: string) => `/company/${companyId}/dashboard/profit-spend`,
    moneyInOut: (companyId: string) => `/company/${companyId}/dashboard/money-in-out`,
    customerSales: (companyId: string) => `/company/${companyId}/dashboard/customer-sales`,
  },
};
